import Api from "../axios"

export const getTotalHour= async ({date})=>{
    return await Api.get(`/total_hours_day?date=${date}`);
}